import { isNil } from 'ramda';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';

import { api } from '~constants';
import { ResponseError, StatusCodes } from '~models';

export const getResponseError = (err: AjaxError): ResponseError => ({
  ...err.response,
  message: err.response?.message || err.response?.error || 'Something went wrong',
  status: err.status,
});
export const getResponsePayload = <T>(res: AjaxResponse): T => res.response;

const isMethodAllowed = (method: string, methods: string[]) => methods.includes(method.toLocaleLowerCase());

export const shouldShowNotification = (url = '', method = '') => {
  switch (true) {
    case /^\/api\/business-units\/[0-9]*$/.test(url) && isMethodAllowed(method, ['delete']): {
      return false;
    }

    case url === api.users.updatePassword && isMethodAllowed(method, ['get']): {
      return false;
    }

    case url === api.users.profile && isMethodAllowed(method, ['get']): {
      return false;
    }

    default:
      return true;
  }
};

export const getHttpBannerError = (err: AjaxError): ResponseError => {
  if (err.request.url === '/api/dealers/import/log' && err.status === StatusCodes.NotFound) {
    return {
      ...err.response,
      message: 'Import Log Not Found',
      status: err.status,
      variant: 'warning',
    };
  }

  if (err.status === StatusCodes.Unauthorized && isNil(err.response)) {
    return {
      message: 'Your session has expired. Please login again.',
      status: err.status,
      variant: 'error',
    };
  }

  return {
    ...getResponseError(err),
    variant: 'error',
  };
};
